import type { AnalyticsEvent, AnalyticsEventPageProperties } from "@octopusdeploy/portal-analytics";
import type { UnknownPageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { Workflow } from "~/workflows/workflows";

interface WorkflowStartedEvent extends AnalyticsEvent<"Workflow Started">, Partial<AnalyticsEventPageProperties> {
    WorkflowId: string;
    WorkflowInstanceId: string;
    WorkflowType: "drawer" | "dialog";
}

interface WorkflowStartedEventArguments {
    workflow: Workflow<unknown, unknown>;
    workflowInstanceId: string;
    pageRegistration: UnknownPageRegistration | null;
}

export function createWorkflowStartedEvent({ workflow, workflowInstanceId, pageRegistration }: WorkflowStartedEventArguments): WorkflowStartedEvent {
    const pageFields: AnalyticsEventPageProperties | undefined =
        pageRegistration === null
            ? undefined
            : {
                  "Page Id": pageRegistration.pageId,
                  "Page Area": pageRegistration.pageArea.mainArea,
              };
    return {
        eventName: "Workflow Started",
        WorkflowId: workflow.workflowId,
        WorkflowType: workflow.workflowType,
        WorkflowInstanceId: workflowInstanceId,
        ...pageFields,
    };
}
